import apiClient from '../api/client';
import { isValidHex } from '../theme/themeUtils';

const BASE = '/api/admin/themes';

const normalize = (t) =>
  t && isValidHex(t.colorCode)
    ? {
        themeId: t.themeId,
        themeCode: t.themeCode,
        themeName: t.themeName,
        colorCode: t.colorCode.toLowerCase(),
        isDefault: !!t.isDefault,
        isUserSelected: !!t.isUserSelected,
      }
    : null;

export const getThemes = async () => {
  const res = await apiClient.get(BASE);
  return (Array.isArray(res.data) ? res.data : []).map(normalize).filter(Boolean);
};

export const getUserTheme = async () => {
  const res = await apiClient.get(`${BASE}/user-theme`);
  return res.status === 204 ? null : normalize(res.data);
};

export const saveUserTheme = async (themeId) => {
  const res = await apiClient.put(`${BASE}/user-theme`, { themeId });
  const saved = normalize(res.data);
  if (!saved) throw new Error('Invalid theme returned from server.');
  return saved;
};